import Document from './stores/document'
import Nav from './stores/nav'

var store = {
  document: new Document(),
  nav: new Nav(),
}

export default store


// WEBPACK FOOTER //
// ./src/store.js